import { use } from 'react';

import { ValidationFormContext } from '../context';

export const useFormSchema = () => {
  const context = use(ValidationFormContext);
  if (!context) {
    throw new Error('[validators]: Form schema components must be used within <FormSchema>');
  }

  return context;
};
